import template from './movingHubButton.template.html';
import templateEdit from './movingHub.template.html';

export default {
  template,
  bindings: {
    contacts: '<',
    owner: '<',
    idTicket: '<',
    idWorkflow: '<',
    isDisabled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdDialog, $mdMedia, movingHubService, uiService, MOVING_HUB) {
      'ngInject';

      const ctrl = this;
      ctrl.isOpenDialog = false;
      ctrl.$mdMedia = $mdMedia;
      ctrl.availableApplicationTypes = [];
      ctrl.availableOfferTypes = [];

      ctrl.initialize = () => {
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.idWorkflow = ctrl.idWorkflow || '';
        ctrl.contacts = _.filter(ctrl.contacts, (c) => !c?.isCompany);
        ctrl.owner = ctrl.owner || {};
        ctrl.availableApplicationTypes = MOVING_HUB.FORM_FIELDS.APPLICATION_TYPES;
        ctrl.availableOfferTypes = MOVING_HUB.FORM_FIELDS.OFFER_TYPES;
      };

      ctrl.openDialog = ($event) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              primaryContact: ctrl.contacts[0] || {},
              owner: ctrl.owner,
              idTicket: ctrl.idTicket,
              idWorkflow: ctrl.idWorkflow,
              availableApplicationTypes: ctrl.availableApplicationTypes,
              availableOfferTypes: ctrl.availableOfferTypes
            },
            template: templateEdit,
            controllerAs: '$ctrl',
            multiple: true,
            controller(
              primaryContact,
              owner,
              idTicket,
              idWorkflow,
              availableApplicationTypes,
              availableOfferTypes
            ) {
              const self = this;
              self.primaryContact = primaryContact;
              self.owner = owner;
              self.idTicket = idTicket;
              self.idWorkflow = idWorkflow;
              self.availableApplicationTypes = availableApplicationTypes;
              self.availableOfferTypes = availableOfferTypes;

              self.movingHubPayload = {
                action: 'application',
                partner_code: '',
                customer: {
                  first_name: self.primaryContact?.person?.information?.firstName,
                  last_name: self.primaryContact?.person?.information?.familyName,
                  email: self.primaryContact?.getEmail(),
                  primary_phone: self.primaryContact?.person?.contact?.primary
                },
                application_type: 0,
                agent_referred: owner?.getEmail(),
                offer_type: 0,
                send_customer_sms: false,
                send_customer_email: false,
                idTicket: self.idTicket,
                idWorkflow: self.idWorkflow,
                idContact: self.primaryContact?.id || ''
              };

              self.canSend = () =>
                self.movingHubPayload?.customer?.first_name !== '' &&
                self.movingHubPayload?.customer?.last_name !== '' &&
                self.movingHubPayload?.customer?.email !== '' &&
                self.movingHubPayload?.customer?.primary_phone !== '' &&
                self.movingHubPayload?.application_type &&
                self.movingHubPayload?.offer_type &&
                (self.movingHubPayload?.send_customer_sms ||
                  self.movingHubPayload?.send_customer_email);

              self.isInvalidPhoneNumber = () => {
                const phone = self.movingHubPayload?.customer?.primary_phone?.onlyNumbers();
                return phone.length !== 10;
              };

              self.confirm = () => {
                if (self.canSend()) {
                  $mdDialog.hide(self.movingHubPayload);
                }
              };
              self.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            movingHubService.send({ params: result }).then((res) => {
              if (res.status) {
                ctrl.onFinished({ data: res.response });
                uiService.toast({
                  text: {
                    p1: 'Application',
                    p2: 'has been successfully',
                    p3: 'sent'
                  },
                  success: true
                });
              }
            });
          });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
